import { Icon } from '@mui/material';
import './ChipAviso.css'; // Archivo CSS para estilos



const ChipAviso = ({ onClick }: { onClick: () => void }) => {

    return (
        <div id={`chipAviso`} onClick={onClick}  >
            <Icon className="chip-icon">notifications</Icon>
            <span className="chip-label">
                AVISO
            </span>
        </div>
    );
};

export default ChipAviso;
